import { InjectionToken } from '@angular/core';
import { CheckoutConfig } from '../models/config/checkout-config.interface';

export const CHECKOUT_CONFIG = new InjectionToken<CheckoutConfig>(
  'Checkout config'
);
